module.exports = __webpack_public_path__ + "img/4.529fdf40.png";